import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  avatar: {
    display: 'block',
    margin: '0 auto',
    width: '150px',
    marginBottom: theme.spacing(2),
  },
}))

export default useStyles
